import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from './../../../../shared/services/api.service';
import { AlertService } from './../../../../shared/services/alert.service';
import { CommunicationService } from './../../../../shared/services/communication.service';
import { ActivatedRoute, Params } from '@angular/router';

const SUCCESS_MESSAGE = 'Položka byla úspěšně smazána.';
const WARNING_MESSAGE = 'Položku se nepodařilo smazat.';
const ERROR_MESSAGE = 'Omlouváme se, došlo k chybě. Zkontrolujte, zda položka existuje.';

@Component({
  selector: 'swb-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})

export class ConfirmationComponent implements OnInit {
  @ViewChild('modal') modal;
  public header = 'Potřebujeme vaše potvrzení';
  public body = 'Opravdu chcete provést vybranou akci?';

  constructor(
    private _apiService: ApiService,
    private _alertService: AlertService,
    private _communicationService: CommunicationService,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['header']) {
        this.header = params['header'];
      }
      if (params['body']) {
        this.body = params['body'];
      }
    });
  }

  modalExecute($event) {
    this._apiService.delete($event).subscribe(
      (response: any) => {
        if ({ ...response }.status && { ...response }.status > 0) {
          const id = { ...response }.id || '';
          this._alertService.success(SUCCESS_MESSAGE);
          this._communicationService.setModalExecuted(id);
        } else {
          this._alertService.warn(WARNING_MESSAGE);
        }
      },
      (error) => {
        this._alertService.error(ERROR_MESSAGE);
      }
    );

    this.modal.closeModal();

  }
}
